export default "__VITE_ASSET__Bng46Nj7__"